<template>
  <div class="hello" style="background-color: #E8E8E8; min-height: 100vh;">
    <div style="padding: 10px 10px;">
      <div style="background-color: #fff; margin-top: 10px; padding: 10px 10px;border-radius: 4px;">
        <van-row>
          <van-col span="24" v-for="item,index in xxkdlist" :key="index" style="border-bottom:1px solid #E8E8E8; padding: 10px 10px;">
            <div style="font-size: 14px; font-weight: 400;color: #000; text-align: left; padding-top: 0px; overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2; -webkit-box-orient: vertical;" @click="clickMethod(item)">{{item.name}}</div>
          </van-col>
        </van-row>
      </div>
      <van-dialog
        v-model="showlbxm"
      >
        <van-row type="flex" style="text-align: left; font-size: 14px; color: #000; padding: 10px 20px 0px 20px;flex-wrap: wrap;">
          <van-col span="24" style="font-size: 20px; font-weight: 800; padding: 0px 0px 0px 0px;">{{newDetail.name}}</van-col>
        </van-row>
        <div style="height: 400px;overflow: scroll;">
          <van-row type="flex" style="text-align: left; font-size: 14px; color: #000; padding: 10px 20px 0px 20px;flex-wrap: wrap;">
            <van-col span="24" style="font-size: 16px; font-weight: 200; padding: 0px 0px 0px 0px;">{{newDetail.note}}</van-col>
          </van-row>
        </div>
      </van-dialog>
      <div style="height: 100px;"></div>
    </div>
  </div>
</template>

<script>
import zdqdUser from '../api/zdqd'
import crudUser from '../api/user'
import { addBaseAplus } from "../utils/baseAplus"
import dd from 'gdt-jsapi'
export default {
  name: 'Zdqd',
  data () {
    return {
      value: '',
      active: 0,
      activeNames: '',
      personPic: require('../assets/picture/person.png'),
      loading: false,
      finished: true,
      xxkdlist: [],
      newDetail: {},
      showlbxm: false
    }
  },
  mounted() {},
  created () {
    zdqdUser.getXxkd().then(res => {
      this.xxkdlist = res.data
    })
  },
  methods: {
    clickMethod(item) {
      this.newDetail.name = item.name
      this.newDetail.note = item.note
      this.showlbxm = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/News.vue